import axios from "axios";

const state = () => ({
  data: [],
  view_data: [],
  search: [],
});

const getters = {
  GET_DATA: (state) => {
    return state.view_data;
  },
};

const actions = {
  FETCH_DATA: ({ commit }) => {
    axios
      .get(`${process.env.VUE_APP_API_URL}groups`)
      .then(function (response) {
        commit("SET_DATA", response.data);
        commit("SET_VIEW_DATA");
      })
      .catch(function (error) {
        commit("SET_DATA", []);
        commit("SET_VIEW_DATA");
        console.error(error);
      });
  },

  FILTER: ({ commit }, text) => {
    commit("SET_SEARCH", text);
    commit("FILTER");
    commit("SET_VIEW_DATA");
  },
};

const mutations = {
  SET_DATA: (state, data) => {
    state.data = data;
  }, //SET_DATA

  SET_VIEW_DATA: (state) => {
    state.view_data = [];

    for (let group of state.data) {
      if (!group.show) continue;

      let copy = Object.assign({}, group);
      copy.sub_groups = [];

      for (let sub of group.sub_groups) {
        if (sub.show) copy.sub_groups.push(sub);
      }

      state.view_data.push(copy);
    }
  }, //SET_VIEW_DATA

  SET_SEARCH: (state, text) => {
    text = text.trim();
    if (!text) {
      state.search = [];
    } else {
      state.search = text.toLowerCase().replace(["ё"], ["е"]).split(" ");
    }
  }, //SET_SEARCH

  FILTER: (state) => {
    let search_text = (group) => {
      let name = group.name.toLowerCase().replace(["ё"], ["е"]);
      let add = true;
      state.search.forEach((text) => {
        if (text != "" && !name.includes(text)) {
          add = false;
        }
      });
      return add;
    };

    for (let group of state.data) {
      let show_subs = false;

      for (let sub_group of group.sub_groups) {
        sub_group.show = search_text(sub_group);
        if (sub_group.show) show_subs = true;
      }

      if (show_subs) {
        group.show = true;
        continue;
      }

      group.show = search_text(group);
      if (group.show && !show_subs) {
        for (let sub_group of group.sub_groups) {
          sub_group.show = true;
        }
      }
    }
  }, //FILTER
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
